<template>
  <v-card>
    <v-card-title class="headline" dark-title>
      Product List of {{ clientName }}
    </v-card-title>
    <v-card-text class="mb-3">
      <ex-card disable-offsets>
        <template>
          <v-data-table
            :items="productsData"
            :headers="productDataHeader"
            :options.sync="pagination"
            :footer-props="{
              'items-per-page-options': rowsPerPageItems,
            }"
            v-if="productsData.length"
            class=""
          >
            <template v-slot:item="{ item, index }">
              <tr @click="$emit('loadProduct', item.product_id)">
                <td>
                  <v-btn
                    text
                    color="primary"
                    class="m-w"
                    @click.stop="$emit('deleteRowOfProductList', index, item)"
                  >
                    <v-icon>close</v-icon>
                  </v-btn>
                </td>
                <td>{{ item.product_brand.name || "_" }}</td>
                <td>
                  <v-tooltip top color="rgba(40, 39, 50, 1)">
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        {{ item.product_name || "_" }}
                      </div>
                    </template>
                    <span
                      >Product Id: {{ item.product_id || "_" }} - Date:
                      {{ item.created_at || "_" }}</span
                    >
                  </v-tooltip>
                </td>
                <td>
                  <div v-for="(i, index) in item.clients" :key="index">
                    {{ i.client_name || "_" }}
                  </div>
                </td>
                <td>
                  <div v-for="(i, index) in item.tracks" :key="index">
                    {{ i || "_" }}
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
        </template>
      </ex-card>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
/* eslint-disable */
export default {
  name: "ProductListTable",
  props: {
    clientName: {
      type: String,
      default: "",
    },
    productsData: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    rowsPerPageItems: [50, 100, 200, 400],
    pagination: {
      rowsPerPage: 200,
    },
    productDataHeader: [
      {
        text: "delete",
        align: "left",
        sortable: false,
        value: "name",
      },
      {
        text: "Product brand",
        align: "left",
        sortable: false,
        value: "name",
      },
      {
        text: "Product Name",
        align: "left",
        sortable: false,
        value: "name",
      },
      {
        text: "Total clients",
        align: "left",
        sortable: false,
        value: "name",
      },
      {
        text: "Total tracks",
        align: "left",
        sortable: false,
        value: "name",
      },
    ],
  }),
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/product/ProductListTable.vue